import {IApplicationData} from "../../../application/types/IApplicationData";
import {ILeadModalLeadType} from "../../../application/types/lead/ILeadModalLeadType";
import {ApplicationSourceSection} from "../../../application/utils/form/application_form_source";
import {IGtmApplication} from "../../../tracking/types/IGtmApplication";
import {ViewType} from "../../../view_type/ViewType";
import {hitGTMOfferPurchase} from "./offer/hit_gtm_offer_purchase";
import {hitGTMPropertyPurchase} from "./property/hit_gtm_property_purchase";
import {IGTMEcommerceAddProductData} from "./types/IGTMEcommerceAddProductData";

export const hitGTMEcommercePurchase = (
    data: IGTMEcommerceAddProductData,
    viewType: ViewType | null,
    leadType: ILeadModalLeadType,
    sourceSection: ApplicationSourceSection | string,
    application: IApplicationData,
    eventCategory?: string
) => {
    const propertyData = (data.property && data.property.detail) || undefined;
    const gtmApplication: IGtmApplication = {
        ...application,
        new_property_notification_consent: Boolean(application.marketing_email || application.marketing_sms)
    };

    if (propertyData) {
        return hitGTMPropertyPurchase(data, viewType, leadType, sourceSection, gtmApplication, eventCategory);
    }

    return hitGTMOfferPurchase(data, viewType, leadType, sourceSection, gtmApplication, eventCategory);
};
